import { render } from "./WhatsAppElectoralMessages.vue?vue&type=template&id=ee369698&scoped=true"
import script from "./WhatsAppElectoralMessages.vue?vue&type=script&lang=js"
export * from "./WhatsAppElectoralMessages.vue?vue&type=script&lang=js"

import "./WhatsAppElectoralMessages.vue?vue&type=style&index=0&id=ee369698&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee369698"]])

export default __exports__